const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  trailingZeroDisplay: "stripIfInteger",
})

export function formatDollars(value: number) {
  if (isNaN(value)) {
    return ""
  }
  return formatter.format(value)
}
